export enum MySavedDealButtonType {
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    PROGRESS = 'progress',
}
